import React from 'react';
import { demeterChartsApi } from '../../../Apis/Apis';
import useApi from '../../Apis/Hooks/useApiHook';
import PageHeader from '../../Components/Headers/PageHeader';
import TableSkeleton from '../../Components/Layout/TableSkeleton';
import useLanguage from '../../Services/Language/useLanguageHook';
import styles from './ChartBuilder.module.scss';
import ChartBuilderFirstChartPage from './ChartBuilderFirstChartPage';
import ChartBuilderListPage from './ChartBuilderListPage';

const ChartBuilderPage: React.FC = () => {
    const [translations] = useLanguage();

    // Api hooks.
    const [, refreshListDemeterCharts, listDemeterChartsResponse] = useApi(() => demeterChartsApi.listDemeterCharts(), {
        errorMessage: translations.chartBuilder.messages.listChartsFailure,
    });

    if (!listDemeterChartsResponse) {
        return (
            <div className={styles.chart_builder_list_page_container}>
                <PageHeader title={translations.chartBuilder.headers.myCharts} />
                <TableSkeleton />
            </div>
        );
    }

    if (listDemeterChartsResponse.rows?.length) {
        return <ChartBuilderListPage listDemeterChartsResponse={listDemeterChartsResponse} refreshListDemeterCharts={refreshListDemeterCharts} />;
    }

    return <ChartBuilderFirstChartPage />;
};

export default ChartBuilderPage;
